/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { TSupportedCountries } from "../messages/premium-calculator.message";

export interface ICoverageCalculatorMessage {
  country: TSupportedCountries;
  premium: number;
  discount: number;
}

interface ICharge {
  raw: number;
  formatted: any;
}

export class CoverageCalculatorMessage {
  public country: string;
  public premium: number;
  public discount: number;
  public insuranceProviderCharge?: ICharge;
  public platformCharge?: ICharge;
  public riskCapitalPremium?: any;
  public totalCoverage?: any;
  constructor({ country, premium, discount }: ICoverageCalculatorMessage) {
    this.country = country;
    this.premium = premium;
    this.discount = discount;
  }
}
